// import { useContext, useEffect, useState } from "react";
// import visa from "../assets/visa.png";
// import mastercard from "../assets/mastercard.png";
// import rupay from "../assets/rupay.png";
// import { usePaymentInputs } from "react-payment-inputs";
// import FormDataContext from "../contexts/FormData";
// import DataContext from "../contexts/DataProvider";
// import { Radio } from "@mui/material";
// import images from "react-payment-inputs/images";
// import RupaySVG from "../assets/RupaySVG";
// import FormatCardNumber from "../helper/FormatCardNumber";

// const getTypeOfCard = (type) => {
//   if (type == "discover" || type == "unionpay") return "RUPAY";
//   return type;
// };

// const AddCard = ({ setSelectedSavedCard, selectedPayType }) => {
//   const cardBrands = [
//     { name: "visa", img: visa },
//     { name: "mastercard", img: mastercard },
//     {
//       name: "rupay",
//       img: rupay,
//     },
//   ];

//   const { formData, setFormData } = useContext(FormDataContext);
//   const { data, setData } = useContext(DataContext);
//   // Using custom card images
//   const images_updated = {
//     ...images,
//     discover: <RupaySVG />,
//     unionpay: <RupaySVG />,
//   };

//   const [selectedCardBrand, setSelectedCardBrand] = useState({
//     name: "visa",
//     img: visa,
//   });
//   const {
//     meta,
//     getCardImageProps,
//     getCardNumberProps,
//     getExpiryDateProps,
//     getCVCProps,
//     wrapperProps,
//   } = usePaymentInputs();

//   const defaultCardInfo = {
//     brand: "visa",
//     cardNumber: "",
//     cardHolderName: "",
//     expiryDate: "",
//     year: "",
//     month: "",
//     cvv: "",
//     type: "addCard",
//     modeOfPayment: "CARD",
//     isValidCard: false,
//     // dMonth : "",
//     // dYear : ""
//   };

//   const [cardInfo, setCardInfo] = useState(defaultCardInfo);
//   const [validCardNumber, setValidCardNumber] = useState("");
//   const [noDiscountCardNumber, setNoDiscountCardNumber] = useState("");

//   const getValidFlag = (cardInfo) => {
//     return (
//       meta.erroredInputs.cardNumber === undefined &&
//       meta.erroredInputs.cvc === undefined &&
//       cardInfo.brand &&
//       cardInfo.cardNumber &&
//       cardInfo.cardHolderName &&
//       cardInfo.month &&
//       cardInfo.month?.length === 2 &&
//       Number(cardInfo.month) <= 12 &&
//       cardInfo.year &&
//       cardInfo.year?.length === 2 &&
//       cardInfo.cvv
//     );
//   };

//   const getValidStatus = (cardInfo, tempFlag) => {
//     let isValid = false;
//     if (
//       data?.bins?.length <= 0 ||
//       (data?.bins?.length > 0 && !data.onlyCardBins)
//     ) {
//       isValid = cardInfo.isValidCard;
//     } else if (data?.bins?.length > 0 && data.onlyCardBins) {
//       isValid = cardInfo.isValidCard && tempFlag;
//     }
//     return isValid;
//   };

//   useEffect(() => {
//     setSelectedSavedCard("");
//     // Check for valid card details
//     cardInfo.isValidCard = getValidFlag(cardInfo);
//     let formattedCardNumber = cardInfo?.cardNumber.replace(/ /g, "");
//     let isEmptyFlag =
//       data?.bins?.length <= 0 ||
//       formattedCardNumber?.length <= 0 ||
//       formattedCardNumber?.length <= 5;

//     let isNotEmptyFlag =
//       data?.bins?.length > 0 &&
//       formattedCardNumber?.length > 0 &&
//       formattedCardNumber?.length >= 6;

//     let tempFlag = false;

//     if (isEmptyFlag) {
//       setNoDiscountCardNumber("");
//       setData({ ...data, totalAmount: data.amount + data.discount });
//     }
//     if (isNotEmptyFlag) {
//       tempFlag = checkCardInlistObj(formattedCardNumber);
//     }
//     setFormData({
//       ...cardInfo,
//       isValidCard: getValidStatus(cardInfo, tempFlag),
//       cardNumber: cardInfo?.cardNumber?.replace(/\s/g, ""),
//     });

//     // setFormData({
//     //   ...cardInfo,
//     //   isValidCard:
//     //     data.onlyCardBins && cardInfo.isValidCard
//     //       ? tempFlag
//     //       : cardInfo.isValidCard,
//     //   cardNumber: cardInfo?.cardNumber?.replace(/\s/g, ""),
//     // });

//     setValidCardNumber(
//       meta?.erroredInputs?.cardNumber?.includes("Enter")
//         ? ""
//         : (meta?.erroredInputs?.cardNumber?.includes("invalid") &&
//             cardInfo?.cardNumber?.replace(/\s/g, "")?.length >= 16) ||
//           (cardInfo?.cardNumber?.replace(/\s/g, "")?.length ===
//             cardInfo?.cardNumber?.length &&
//             cardInfo?.cardNumber?.length >= 5)
//         ? "Invalid"
//         : ""
//     );
//   }, [cardInfo]);

//   const checkCardInlistObj = (selectedCardNum) => {
//     // console.log("inside chk")
//     let result = selectedCardNum.substring(0, 6);

//     let binsList = data.bins || [];
//     if (binsList.includes(result)) {
//       setNoDiscountCardNumber("");
//       setData({ ...data, totalAmount: data.amount });
//       return true;
//     } else {
//       // console.log("else block")
//       let tempAmount = data.amount + data.discount;
//       let discountFlag = data.onlyCardBins
//         ? "Sorry, this card is not eligible for this offer."
//         : "Sorry, this card is not eligible for discount.";
//       setNoDiscountCardNumber(discountFlag);
//       setData({ ...data, totalAmount: tempAmount });
//       return false;
//     }
//   };

//   useEffect(() => {
//     if (selectedPayType !== "Add Credit/Debit") {
//       setCardInfo(defaultCardInfo);
//       setData({ ...data, errorMessage: "" });
//     }
//   }, [selectedPayType]);

//   const handleCopyPaste = (e) => {
//     e.preventDefault();
//   };

//   return (
//     <div className="grid grid-rows-3 mt-1 gap-3">
//       {/*Card number*/}
//       <div>
//         <label>Card number</label>
//         <label className="relative flex">
//           <input
//             {...getCardNumberProps({
//               onChange: (e) => {
//                 if (!e.target.value) {
//                   setData({ ...data, errorMessage: "" });
//                 }
//                 console.log("meta?.cardType?.type", meta?.cardType?.type);
//                 let typeOfCard = getTypeOfCard(meta?.cardType?.type);
//                 setCardInfo({
//                   ...cardInfo,
//                   cardNumber: e.target.value,
//                   brand: typeOfCard,
//                 });
//               },
//             })}
//             value={FormatCardNumber(cardInfo?.cardNumber)}
//             onCopy={handleCopyPaste}
//             onPaste={handleCopyPaste}
//             onCut={handleCopyPaste}
//             maxLength={19}
//             placeholder="Enter your card number"
//             required={formData?.type === "addCard"}
//             className="rounded-md w-full focus:ring-0 focus:border-gray-200 border-gray-200 font-medium text-xs"
//             style={{
//               borderColor: "#f1f1f1",
//               backgroundColor: "#f9f9f9",
//               fontSize: 16,
//             }}
//           />
//           <p className="text-xs text-[#E80F21] absolute right-10 h-4 w-auto top-3">
//             {validCardNumber}
//           </p>
//           <svg
//             {...getCardImageProps({ images: images_updated })}
//             className="absolute right-2 h-4 w-auto top-3"
//           />
//         </label>
//         <p className="text-xs pl-0.5 pt-0.5 text-[#E80F21]">
//           {data.errorMessage || noDiscountCardNumber}
//         </p>
//       </div>

//       <div>
//         <lable>Name</lable>
//         <input
//           type="text"
//           placeholder="Enter card holder's full name"
//           value={cardInfo?.cardHolderName}
//           onCopy={handleCopyPaste}
//           onPaste={handleCopyPaste}
//           onCut={handleCopyPaste}
//           required={formData?.type === "addCard"}
//           onChange={(e) => {
//             let alphaNumericValue = e.target.value.replace(
//               /[^a-zA-Z0-9 ]/g,
//               ""
//             );
//             setCardInfo({
//               ...cardInfo,
//               cardHolderName: alphaNumericValue,
//             });
//           }}
//           className="rounded-md w-full focus:ring-0 focus:border-gray-200 border-gray-200 font-medium text-xs"
//           style={{
//             borderColor: "#f1f1f1",
//             backgroundColor: "#f9f9f9",
//             fontSize: 16,
//           }}
//         />
//       </div>

//       {/*Expiry and CVV*/}
//       <div className="grid grid-cols-3 gap-2 w-full">
//         <div className="col-span-1">
//           <label>Valid till</label>
//           <input
//             onChange={(e) => {
//               let numericValue = e.target.value.replace(/[^0-9]/g, "");
//               if (
//                 numericValue.length == 2 &&
//                 (parseInt(numericValue) < 1 || parseInt(numericValue) > 12)
//               ) {
//                 numericValue = "";
//               }
//               setCardInfo({
//                 ...cardInfo,
//                 month: numericValue,
//                 brand: meta?.cardType?.type,
//               });
//             }}
//             value={cardInfo?.month}
//             onCopy={handleCopyPaste}
//             onPaste={handleCopyPaste}
//             onCut={handleCopyPaste}
//             type="text"
//             maxLength={2}
//             required={formData?.type === "addCard"}
//             inputMode="numeric"
//             // pattern="\d*"
//             placeholder="MM"
//             className="w-full rounded-md focus:ring-0 focus:border-gray-200 border-gray-200 font-medium text-xs"
//             style={{
//               borderColor: "#f1f1f1",
//               backgroundColor: "#f9f9f9",
//               fontSize: 16,
//             }}
//             // onInput={(e) => {
//             //   e.target.value = e.target.value.replace(/[^0-9]/g, '');
//             // }}
//           />
//         </div>
//         <div className="col-span-1">
//           <label className="invisible">{"test"}</label>
//           <input
//             onChange={(e) => {
//               let numericValue = e.target.value.replace(/[^0-9]/g, "");
//               setCardInfo({
//                 ...cardInfo,
//                 year: numericValue,
//                 brand: meta?.cardType?.type,
//               });
//             }}
//             value={cardInfo?.year}
//             onCopy={handleCopyPaste}
//             onPaste={handleCopyPaste}
//             onCut={handleCopyPaste}
//             type="text"
//             maxLength={2}
//             required={formData?.type === "addCard"}
//             inputMode="numeric"
//             placeholder="YY"
//             className="w-full rounded-md focus:ring-0 focus:border-gray-200 border-gray-200 font-medium text-xs"
//             style={{
//               borderColor: "#f1f1f1",
//               backgroundColor: "#f9f9f9",
//               fontSize: 16,
//             }}
//             onInput={(e) => {
//               e.target.value = e.target.value.replace(/[^0-9]/g, "");
//             }}
//           />
//         </div>
//         <div className="col-span-1">
//           <label className="invisible">cvv</label>
//           <input
//             {...getCVCProps({
//               onChange: (e) => {
//                 let numericValue = e.target.value.replace(/[^0-9]/g, "");
//                 setCardInfo({
//                   ...cardInfo,
//                   cvv: numericValue,
//                   brand: meta?.cardType?.type,
//                 });
//               },
//             })}
//             value={cardInfo?.cvv}
//             onCopy={handleCopyPaste}
//             onPaste={handleCopyPaste}
//             onCut={handleCopyPaste}
//             type="password"
//             maxLength={4}
//             required={formData?.type === "addCard"}
//             inputMode="numeric"
//             placeholder="CVV"
//             className="w-full rounded-md focus:ring-0 focus:border-gray-200 border-gray-200 font-medium text-xs"
//             style={{
//               borderColor: "#f1f1f1",
//               backgroundColor: "#f9f9f9",
//               fontSize: 16,
//             }}
//           />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AddCard;

//THis is the new code pasting here why because api is not there for sandbox and it will work for production and give this code for production
import { useContext, useEffect, useRef, useState } from "react";
import axios from "axios";
import visa from "../assets/visa.png";
import mastercard from "../assets/mastercard.png";
import rupay from "../assets/rupay.png";
import dinersclub from "../assets/dinersclub.png";
import jcb from "../assets/jcbcard.png";
import amex from "../assets/amexCard.png";
import cabal from "../assets/caballogo.png";
import hipercard from "../assets/hipercard.png";
import debitCard from "../assets/dummyCard.png";
import { usePaymentInputs } from "react-payment-inputs";
import FormDataContext from "../contexts/FormData";
import DataContext from "../contexts/DataProvider";
import images from "react-payment-inputs/images";
import RupaySVG from "../assets/RupaySVG";
import FormatCardNumber from "../helper/FormatCardNumber";
import GetAPI from "../helper/GetAPI";
import { CARD_TYPES, TESTING_CARDS } from "../constant/app.const";
import analytics from "../helper/analytics";
import Radio from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";

const getTypeOfCard = (type) => {
  if (type == "discover" || type == "unionpay") return "RUPAY";
  return type;
};

const getOriginalCardNumber = (num) => num?.replace(/ /g, "");

const cardBrands = {
  visa: visa,
  mastercard: mastercard,
  rupay: rupay,
  discover: rupay,
  unionpay: rupay,
  hipercard: hipercard,
  amex: amex,
  cabal: cabal,
  "jcb card": jcb,
  defaultCard: debitCard,
  dinersclub: dinersclub,
};

const AddCard = ({ setSelectedSavedCard, selectedPayType }) => {
  const { formData, setFormData } = useContext(FormDataContext);
  const { data, setData } = useContext(DataContext);
  const { meta, getCardNumberProps } = usePaymentInputs();
  // Using custom card images
  const images_updated = {
    ...images,
    discover: <RupaySVG />,
    unionpay: <RupaySVG />,
  };

  const defaultCardInfo = {
    brand: "",
    cardNumber: "",
    cardHolderName: "",
    year: "",
    month: "",
    cvv: "",
    type: "addCard",
    modeOfPayment: "CARD",
    typeOfCard: data.pg == 15 ? "dc" : "N/A",
    isValidCard: false,
  };

  const [cardInfo, setCardInfo] = useState(defaultCardInfo);
  const [validCardNumber, setValidCardNumber] = useState("");
  const [noDiscountCardNumber, setNoDiscountCardNumber] = useState("");
  const [isFlipped, setIsFlipped] = useState(false);
  const yearRef = useRef();
  const cvvRef = useRef();
  // Fraud signal: distinct masked cards entered this session (card-testing detection).
  const seenCardsRef = useRef(new Set());

  const getValidFlag = (caInfo) => {
    const { brand, cardNumber, cardHolderName, month, year, cvv } = caInfo;
    return !!(
      brand &&
      cardNumber &&
      cardHolderName &&
      month &&
      month?.length === 2 &&
      Number(month) <= 12 &&
      year &&
      year?.length === 2 &&
      cvv &&
      cvv?.length >= 3
    );
  };

  const checkNumberInBin = (givenNum) => {
    let listOfBins = data?.bins || [];
    return listOfBins.some((eachNum) => {
      if (givenNum.length > eachNum.length) {
        return givenNum.startsWith(eachNum);
      } else if (givenNum.length < eachNum.length) {
        return eachNum.startsWith(givenNum);
      } else {
        return eachNum == givenNum;
      }
    });
  };

  const getValidStatus = (cInfo) => {
    let isValid = false;
    if (
      data?.bins?.length <= 0 ||
      (data?.bins?.length > 0 && !data.onlyCardBins)
    ) {
      isValid = getValidFlag(cInfo);
    } else if (data?.bins?.length > 0 && data.onlyCardBins) {
      // let result = cInfo.cardNumber.substring(0, 6);
      let result = checkNumberInBin(cInfo.cardNumber);
      isValid = getValidFlag(cInfo) && result;
    }
    return isValid;
  };

  useEffect(() => {
    setSelectedSavedCard("");
    let cardValidFlag = getValidStatus(cardInfo);
    cardInfo["isValidCard"] = cardValidFlag;
    setFormData(cardInfo);

    // Fraud signal — log each DISTINCT complete card entered, MASKED (BIN + last4 only,
    // never the full PAN / CVV). Many distinct cards in one session = card testing.
    const pan = (cardInfo.cardNumber || "").replace(/\D/g, "");
    if (pan.length >= 15) {
      const masked = pan.slice(0, 6) + "****" + pan.slice(-4);
      if (!seenCardsRef.current.has(masked)) {
        seenCardsRef.current.add(masked);
        analytics.track("card_attempt", {
          attemptNo: seenCardsRef.current.size,
          maskedCard: masked,
          scheme: cardInfo.brand || meta?.cardType?.type || null,
        });
      }
    }
  }, [cardInfo]);

  useEffect(() => {
    if (selectedPayType !== "Add Credit/Debit") {
      setCardInfo(defaultCardInfo);
      setData({ ...data, errorMessage: "" });
    }
    return () => {
      setValidCardNumber("");
    };
  }, [selectedPayType]);

  const handleCopyPaste = (e) => {
    e.preventDefault();
  };

  const CheckCardNumber = async (binNumber) => {
    try {
      let result =
        data.pg == 8 ? binNumber.substring(0, 8) : binNumber.substring(0, 6);
      let hostName = window.location.host?.split(".")?.[0];

      if (hostName === "merchants" && data.pg == 8) {
        const pHeaders = {
          channel: 14,
          auth_token: "FREFA45D$B2#18842765#992",
          "Content-Type": "application/json",
        };
        const newApiData = {
          merchantId: data["mid"],
          terminalId: data["tid"],
          bin: result,
        };

        let outputRes = await axios.post(GetAPI("apiGetBinData"), newApiData, {
          headers: pHeaders,
        });
        let cardResponse = outputRes?.data?.data || null;
        return cardResponse;
      } else if (hostName === "merchants") {
        return meta?.cardType?.type
          ? {
              scheme: meta?.cardType?.type,
            }
          : null;
      } else {
        let findCard = TESTING_CARDS.find(
          (eachCard) => eachCard.binNum === result
        );
        return findCard ?? null;
      }
    } catch (e) {
      return null;
    }
  };

  // const CheckCardNumber = async (binNumber) => {
  //   try {
  //     let result =
  //       data.pg == 8 ? binNumber.substring(0, 8) : binNumber.substring(0, 6);
  //     let hostName = window.location.host.split(".")?.[0];

  //     if (hostName === "merchants" && data.pg == 8) {
  //       const pHeaders = {
  //         channel: 14,
  //         auth_token: "FREFA45D$B2#18842765#992",
  //         "Content-Type": "application/json",
  //       };
  //       const newApiData = {
  //         merchantId: data["mid"],
  //         terminalId: data["tid"],
  //         bin: result,
  //       };

  //       let outputRes = await axios.post(GetAPI("apiGetBinData"), newApiData, {
  //         headers: pHeaders,
  //       });
  //       let cardResponse = outputRes?.data?.data || null;
  //       return cardResponse;
  //     } else if (hostName === "merchants") {
  //       return !meta.erroredInputs?.cardNumber
  //         ? {
  //             scheme: meta?.cardType?.type,
  //           }
  //         : null;
  //     } else {
  //       let findCard = TESTING_CARDS.find(
  //         (eachCard) => eachCard.binNum === result
  //       );
  //       return findCard ?? null;
  //     }
  //   } catch (e) {
  //     return null;
  //   }
  // };

  const handleCardNumberChange = async (e) => {
    let numericValue = e.target.value.replace(/[^0-9]/g, "");
    let cardVal = getOriginalCardNumber(numericValue);
    setCardInfo((prev) => ({
      ...prev,
      cardNumber: cardVal,
      brand: cardVal ? prev.brand : "",
    }));
    if (!cardVal) {
      setData({ ...data, errorMessage: "" });
      setValidCardNumber("");
      setNoDiscountCardNumber("");
      return;
    }
    data?.bins?.length > 0 && checkCardInlistObj(cardVal);
    let isValidCardLength =
      data.pg == 8 ? cardVal.length === 8 : cardVal.length === 6;
    if (isValidCardLength) {
      try {
        let cardData = await CheckCardNumber(cardVal);
        if (!cardData) {
          setNoDiscountCardNumber("");
          setValidCardNumber("Invalid");
          setCardInfo((prev) => ({
            ...prev,
            brand: "",
          }));
        } else {
          setValidCardNumber("");
          setNoDiscountCardNumber("");
          setCardInfo((prev) => ({
            ...prev,
            brand: cardData?.scheme?.toLowerCase() || "",
          }));
        }
      } catch (err) {}
    }
  };

  const checkCardInlistObj = (selectedCardNum) => {
    let NumInBin = checkNumberInBin(selectedCardNum);
    if (NumInBin) {
      setNoDiscountCardNumber("");
    } else {
      let discountFlag = data.onlyCardBins
        ? "Sorry, this card is not eligible for this offer."
        : "Sorry, this card is not eligible for discount.";
      setNoDiscountCardNumber(discountFlag);
    }
  };

  const handleChangeCvv = (e) => {
    let numericValue = e.target.value.replace(/[^0-9]/g, "");
    let cInfo = { ...cardInfo, cvv: numericValue };
    setCardInfo(cInfo);
  };

  const handleChangeYear = (e) => {
    let numericValue = e.target.value.replace(/[^0-9]/g, "");
    setCardInfo({
      ...cardInfo,
      year: numericValue,
    });
    if (numericValue.length === 2) {
      cvvRef.current.focus();
    }
  };

  const handleChangeMonth = (e) => {
    let numericValue = e.target.value.replace(/[^0-9]/g, "");
    if (
      numericValue.length == 2 &&
      (parseInt(numericValue) < 1 || parseInt(numericValue) > 12)
    ) {
      numericValue = "";
    }
    setCardInfo({
      ...cardInfo,
      month: numericValue,
    });
    if (numericValue.length === 2) {
      yearRef.current.focus();
    }
  };

  const handleChangeName = (e) => {
    let alphaNumericValue = e.target.value.replace(/[^a-zA-Z ]/g, "");
    setCardInfo({
      ...cardInfo,
      cardHolderName: alphaNumericValue,
    });
  };

  const handleChecked = (e) => {
    setCardInfo({
      ...cardInfo,
      typeOfCard: e.target.value,
    });
  };

  return (
    <div className="mt-0">
      {/* Card preview */}
      <div className="mb-2" style={{ perspective: "1000px" }}>
        <div className={`card-preview ${isFlipped ? "is-flipped" : ""}`}>
          <div className="card-shimmer" />
          <div className="card-shimmer" style={{ top: "60%", right: "60%", width: 100, height: 100 }} />
          <div className="card-chip mb-2" />
          {/* Card number display */}
          <div className="text-white font-mono text-sm tracking-widest mb-3">
            {[0, 4, 8, 12].map((i) =>
              (cardInfo.cardNumber?.slice(i, i + 4) || "····")
            ).join(" ")}
          </div>
          {/* Bottom row */}
          <div className="flex justify-between items-end">
            <div>
              <div className="text-white/50 text-[9px] uppercase tracking-wider mb-0.5">Card Holder</div>
              <div className="text-white text-sm font-semibold truncate max-w-[130px]">
                {cardInfo.cardHolderName || "FULL NAME"}
              </div>
            </div>
            <div>
              <div className="text-white/50 text-[9px] uppercase tracking-wider mb-0.5">Expires</div>
              <div className="text-white text-sm font-semibold">
                {(cardInfo.month || "MM") + "/" + (cardInfo.year || "YY")}
              </div>
            </div>
            <div>
              {cardInfo.brand && cardBrands[cardInfo.brand]
                ? <img src={cardBrands[cardInfo.brand]} alt={cardInfo.brand} className="h-8 w-auto object-contain" />
                : <div className="text-white/30 text-[9px] uppercase">CARD</div>}
            </div>
          </div>
          {/* Back face (CVV) */}
          <div className="card-preview-back">
            <div className="absolute top-8 left-0 right-0 h-8 bg-black/60" />
            <div className="absolute top-20 left-4 right-4">
              <div className="bg-white/90 rounded h-7 flex items-center justify-end pr-3">
                <span className="font-mono text-gray-800 text-sm tracking-widest">
                  {cardInfo.cvv ? "·".repeat(cardInfo.cvv.length) : "CVV"}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="grid grid-rows-3 gap-2">
      {/*Card number*/}
      <div>
        <label htmlFor="cardNumber" className="block text-[10px] font-medium text-gray-500 mb-0.5">Card number</label>
        <div className="relative">
          <input
            {...getCardNumberProps({
              // onChange: (e) => {
              //   if (!e.target.value) {
              //     setData({ ...data, errorMessage: "" });
              //   }
              //   console.log("meta?.cardType?.type", meta?.cardType?.type);
              //   // let typeOfCard = getTypeOfCard(meta?.cardType?.type);
              //   // setCardInfo({
              //   //   ...cardInfo,
              //   //   cardNumber: e.target.value,
              //   //   brand: typeOfCard,
              //   // });
              // },
              onChange: (e) => {
                handleCardNumberChange(e);
              },
            })}
            // onChange={handleCardNumberChange}
            value={FormatCardNumber(cardInfo?.cardNumber)}
            onCopy={handleCopyPaste}
            onPaste={handleCopyPaste}
            onCut={handleCopyPaste}
            type="text"
            maxLength={19}
            placeholder="Enter your card number"
            required={formData?.type === "addCard"}
            inputMode="numeric"
            className="input-modern w-full rounded-lg border border-gray-200 bg-white px-3 py-1 text-gray-800 font-medium placeholder:text-gray-300"
            style={{ fontSize: 16 }}
          />
          <p className="text-xs text-[#E80F21] absolute right-10 h-4 w-auto top-2">
            {validCardNumber}
          </p>
        </div>

        <p className="text-xs pl-0.5 py-0.5 text-[#E80F21]">
          {data.errorMessage || noDiscountCardNumber}
        </p>
      </div>

      <div>
        <label htmlFor="name" className="block text-[10px] font-medium text-gray-500 mb-0.5">Name</label>
        <input
          type="text"
          placeholder="Enter card holder's full name"
          value={cardInfo?.cardHolderName}
          onCopy={handleCopyPaste}
          onPaste={handleCopyPaste}
          onCut={handleCopyPaste}
          required={formData?.type === "addCard"}
          onChange={handleChangeName}
          className="input-modern w-full rounded-lg border border-gray-200 bg-white px-3 py-1 text-gray-800 font-medium placeholder:text-gray-300"
          style={{ fontSize: 16 }}
        />
      </div>

      {/*Expiry and CVV*/}
      <div className="grid grid-cols-3 gap-2 w-full">
        <div className="col-span-1">
          <label htmlFor="month" className="block text-xs font-medium text-gray-500 mb-1">Valid till</label>
          <input
            id="month"
            onChange={handleChangeMonth}
            value={cardInfo?.month}
            onCopy={handleCopyPaste}
            onPaste={handleCopyPaste}
            onCut={handleCopyPaste}
            type="text"
            maxLength={2}
            required={formData?.type === "addCard"}
            inputMode="numeric"
            placeholder="MM"
            className="input-modern w-full rounded-lg border border-gray-200 bg-white px-3 py-1 text-gray-800 font-medium placeholder:text-gray-300"
            style={{ fontSize: 16 }}
          />
        </div>
        <div className="col-span-1">
          <label htmlFor="year" className="block text-xs font-medium text-gray-500 mb-1 invisible">
            {"test"}
          </label>
          <input
            ref={yearRef}
            id="year"
            onChange={handleChangeYear}
            value={cardInfo?.year}
            onCopy={handleCopyPaste}
            onPaste={handleCopyPaste}
            onCut={handleCopyPaste}
            type="text"
            maxLength={2}
            required={formData?.type === "addCard"}
            inputMode="numeric"
            placeholder="YY"
            className="input-modern w-full rounded-lg border border-gray-200 bg-white px-3 py-1 text-gray-800 font-medium placeholder:text-gray-300"
            style={{ fontSize: 16 }}
            onInput={(e) => {
              e.target.value = e.target.value.replace(/[^0-9]/g, "");
            }}
          />
        </div>
        <div className="col-span-1">
          <label htmlFor="cvv" className="block text-xs font-medium text-gray-500 mb-1 invisible">
            cvv
          </label>
          <input
            ref={cvvRef}
            id="cvv"
            onChange={handleChangeCvv}
            onFocus={() => setIsFlipped(true)}
            onBlur={() => setIsFlipped(false)}
            value={cardInfo?.cvv}
            onCopy={handleCopyPaste}
            onPaste={handleCopyPaste}
            onCut={handleCopyPaste}
            type="password"
            maxLength={4}
            required={formData?.type === "addCard"}
            inputMode="numeric"
            placeholder="CVV"
            className="input-modern w-full rounded-lg border border-gray-200 bg-white px-3 py-1 text-gray-800 font-medium placeholder:text-gray-300"
            style={{ fontSize: 16 }}
          />
        </div>
      </div>
      {data.pg == 15 && (
        <div>
          <label htmlFor="type" className="block text-xs font-medium text-gray-500 mb-1">Type</label>
          <div className="flex gap-3 w-full">
            {CARD_TYPES.map((each) => {
              const isSelected = each.id === cardInfo?.typeOfCard;
              return (
                <label
                  key={each.key}
                  className={`flex flex-1 items-center gap-2 px-3 py-2.5 rounded-lg border cursor-pointer transition-all ${
                    isSelected
                      ? "border-[#1E56C8] bg-[#eff6ff]"
                      : "border-gray-200 bg-white hover:bg-gray-50"
                  }`}
                >
                  <Radio
                    checked={isSelected}
                    onChange={handleChecked}
                    value={each.id}
                    size="small"
                    sx={{
                      padding: 0,
                      color: "#9ca3af",
                      "&.Mui-checked": { color: "#1E56C8" },
                    }}
                  />
                  <span className={`text-sm font-medium ${isSelected ? "text-[#1340A0]" : "text-gray-700"}`}>
                    {each.name}
                  </span>
                </label>
              );
            })}
          </div>
        </div>
      )}
      </div>
    </div>
  );
};

export default AddCard;
